import { useEffect, useState } from "react";

/** Announce each message once; the visual typewriter is decorative. */
export function DebriefMessage({
  text,
  onFinished,
}: {
  text: string;
  onFinished?: () => void;
}) {
  const [count, setCount] = useState(() =>
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
      ? text.length
      : 0,
  );
  const [skip, setSkip] = useState(false);
  useEffect(() => {
    const media = window.matchMedia?.("(prefers-reduced-motion: reduce)");
    let shown = 0;
    const tick = () => {
      shown = media?.matches ? text.length : Math.min(text.length, shown + 2);
      setCount(shown);
      if (shown === text.length) window.clearInterval(timer);
    };
    const timer = window.setInterval(tick, 22);
    return () => window.clearInterval(timer);
  }, [text]);
  const typing = !skip && count < text.length;
  useEffect(() => {
    if (typing || !onFinished) return;
    const timer = window.setTimeout(onFinished, 1200);
    return () => window.clearTimeout(timer);
  }, [typing, onFinished]);
  return (
    <div className="debrief-message">
      <h3>
        <span className="sr-only" aria-live="polite">
          {text}
        </span>
        <span aria-hidden="true">
          {skip ? text : text.slice(0, count)}
          {typing && <span className="debrief-cursor">▌</span>}
        </span>
      </h3>
      {typing && (
        <button
          type="button"
          className="debrief-skip"
          onClick={() => setSkip(true)}
        >
          Show full message
        </button>
      )}
    </div>
  );
}
